<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">住院列表</div>
				<div class="titleR">
					
				</div>
			</div>
			<div class="content">
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">全部</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">住院中</div>
							<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">已离院</div>
						</div>
						<div class="tabLineR">
							
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:180px;margin-right: 10px;" placeholder="请输入顾客名称或手机号" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">支付状态</div>
							<el-select style="width:100px" v-model="search.isPay" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'未支付',value:0},{label:'已支付',value:1}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="住院单号" prop="id" min-width="90">
							</el-table-column>
							<el-table-column label="顾客" prop="memberName" min-width="80">
							</el-table-column>
							<el-table-column label="手机号" prop="memberMobile" min-width="100">
							</el-table-column>
							<el-table-column label="昵称" prop="petName" min-width="80">
							</el-table-column>
							<el-table-column label="品种" prop="typeName" min-width="80">
							</el-table-column>
							<el-table-column label="年龄" prop="birthDay" min-width="80">
								<template slot-scope="props">
									<div v-if="props.row.birthDay&&props.row.birthDay.length>4">
										{{$public.FAge(new Date(props.row.birthDay).getTime())[0]}}年{{$public.FAge(new Date(props.row.birthDay))[1]}}月
									</div>
								</template>
							</el-table-column>
							<el-table-column label="经办人" min-width="80">
								<template slot-scope="props">
									<div>{{props.row.handlerName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="截止时间" min-width="150">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.beginDate,'YYYY/MM/DD')}}-{{$public.FTime(props.row.endDate,'YYYY/MM/DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="时长" min-width="90">
								<template slot-scope="props">
									<!-- <div>{{$public.FAge(props.row.beginDate,props.row.endDate)[2]}}日</div> -->
									<div>{{props.row.inHospitalDuration}}</div>
								</template>
							</el-table-column>
							<el-table-column label="创建时间" min-width="120">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime,'YYYY/MM/DD HH:mm')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="住院情况" min-width="70">
								<template slot-scope="props">
									<div v-if="props.row.payInfo">
										<div style="color:red"  v-if="props.row.payInfo.payCount===0">未支付</div>
										<div style="color:#18A44C"  v-if="props.row.payInfo.payCount===1">已支付</div>
									</div>
									<div v-else>
										<div style="color:#18A44C">{{props.row.status==1?'住院中':''}}</div>
										<div style="color:#B7B7B7">{{props.row.status==2?'已离院':''}}</div>
									</div>
								</template>
							</el-table-column> 
							<el-table-column label="状态" min-width="50">
								<template slot-scope="props">
									<span v-if="props.row.consumeMoney>props.row.deposit" style="color:red">已欠费</span>
									<span v-else>
										<span v-if="props.row.payInfo&&props.row.payInfo.payCount==0" style="color:#B05B12">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
										<span v-if="props.row.payInfo&&props.row.payInfo.payCount>0" style="color:#18A44C">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
									</span>
								</template>
							</el-table-column>
							<el-table-column label="入住房间" width="200">
					<template slot-scope="props">
						<div  v-if="props.row.joinCage==1">
						{{props.row.cageInfo.positionName}}{{props.row.cageInfo.cageName}} 
                     <el-button type="text" size="mini" @click="changeCage(props.row,type)">搬家</el-button>
                    <el-button type="text" size="mini" @click="removeCage(props.row)">移出</el-button></div>
					<div  v-if="props.row.joinCage==0&&props.row.status==2&&props.row.cageInfo">
						{{props.row.cageInfo.positionName}}{{props.row.cageInfo.cageName}} 
                  </div>
                   <el-button v-if="props.row.joinCage==0&&props.row.status==1" type="text" size="mini" @click="AddCage(props.row,type)">入住</el-button>
					</template>
				</el-table-column>
							<el-table-column label="操作" min-width="120">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-editzhuyuan')"
									v-if="props.row.status==1"
									type="text" @click="toEdit(props.row)" size="mini">编辑</el-button>
									<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-delzhuyuan')"
									v-if="props.row.status!=2"
									type="text" @click="del(props.row)" size="mini">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
		<div v-if="petCageState">
        <drawerZhuyuanPetCage
          :petId="petId"
		  :qwe="qwe"
		  :type="type"
		  :apply_type="apply_type"
          @submit="submit_drawerStatus"
        ></drawerZhuyuanPetCage>
      </div>
	  <div v-if="petCageAddState">
        <drawerZhuyuanAddPetCage
          :petId="petId"
		  :type="type"
		  :apply_type="apply_type"
          @submit="submit_drawerAddStatus"
        ></drawerZhuyuanAddPetCage>
      </div>
	</div>
</template>
<script>
	import drawerZhuyuanPetCage from "../../../../components/drawerPetCage/drawer_ZhuyuanPetCage.vue";
	import drawerZhuyuanAddPetCage from "../../../../components/drawerPetCage/drawer_ZhuyuanAddPetCage.vue";
	import page from "../../../../components/page.vue"
	export default {
		components:{page,drawerZhuyuanPetCage,drawerZhuyuanAddPetCage},
		data(){
			return{
				search:{
					status:0,
					isPay:-1,
					keyword:'',
					begin_time:'',
					end_time:'',
				},
				tableData:[],
				tabIndex:0,
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				 // 宠物笼子
				 petCageState: false,
				 petCageAddState:false,
				  petId:"",
				  qwe:'',
				  qwe1:'',
				  type:'change',
				  apply_type:'', //猫狗分类
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			zhuyuanParams(){
				return this.$store.state.yiliaoxin.zhuyuanParams;
			},
		},
		beforeRouteEnter(to,from,next){
			next(vm=>{
				if(vm.page.page===1){
					vm.getTableData();
				}
			})
		},
		created(){
			this.page.page = this.zhuyuanParams.curPage||1
		},
		mounted(){
			this.tabIndex = this.zhuyuanParams.initialDataOflist.tabIndex||this.tabIndex;
			this.search = this.zhuyuanParams.initialDataOflist.search||this.search;
			this.page = this.zhuyuanParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			AddCage(row,type){
                this.petId=row.petId;
				this.qwe1=row;
				this.apply_type=row.classType
				type="change"
				this.petCageAddState = true;
			},
			// 搬家
			changeCage(row,type){
				this.petId=row.petId;
				this.qwe=row.cageInfo;
				this.apply_type=row.classType
				console.log(this.apply_type,"this.apply_typethis.apply_typethis.apply_typethis.apply_type");
				type="change"
				this.petCageState = true;
			},
			submit_drawerStatus(obj) {
				if (obj.type == "submit") {
				this.qwe.positionId=obj.positionId
				this.qwe.positionName=obj.positionName
				this.qwe.cageId=obj.cageId
				this.qwe.cageName=obj.cageName
				this.getTableData()
                this.petCageState = false;
			  }else{
				this.petCageState = false;
				}
                },
				submit_drawerAddStatus(obj){
					if (obj.type == "submit") {
					this.qwe1.cageInfo=obj.cageInfo
					this.getTableData()
                   this.petCageAddState = false;
				}else{
					this.petCageAddState = false;
				}
				},
			toEdit(row){
				this.zhuyuanParams.curRow = row
				this.zhuyuanParams.type = 'edit'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
				this.$store.commit("yiliaoxin/add_router",{name:'住院',data:this.zhuyuanParams})
			},
			toSee(row){
				this.zhuyuanParams.curRow = row
				this.zhuyuanParams.type = 'see'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
				this.$store.commit("yiliaoxin/add_router",{name:'住院',data:this.zhuyuanParams})
			},
			reset(){
				this.search.status=0;
				this.search.isPay=-1;    // 是否支付
				this.search.keyword='';
				this.page.page=1;
				this.getTableData()
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
				// 移出
				removeCage(row){
					console.log(row,"??????row");
				this.$confirm('确定要把宠物移出笼子?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(process.env.VUE_APP_apiHost +'api/InHospital/removeCage', {petId:row.petId}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '移出成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 删除
			del(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/InHospital/Delete', {inHospitalId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			leave(row){
				this.$confirm('确定要离院?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/InHospital/Leave', {inHospitalId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '离院成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 切换列表
			changeTabIndex(index){
				this.tabIndex=index;
				if(index==0){
					this.search.status = index;
				}else if(index==1){
					this.search.status = index;
				}else if(index==2){
					this.search.status = index;
				}
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.zhuyuanParams.curPage = num
				this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"petId": '',
					"memberId": "",
					"status": this.search.status, // 0不限；1：住院中；2：已离院
					isPay:this.search.isPay,  // （-1不限：0未支付；1：已支付）
					"depositType": 0,  // (0不限；1：押金；2：余额)
					"startTime": "",
					"endTime": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword":(this.search.keyword).trim()
				}
				let loading=this.$loading();
				this.$http.post('/api/InHospital/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						console.log('zhuyaun123',res.data);
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.zhuyuanParams.initialDataOflist = {
					tabIndex:this.tabIndex,
					search:this.search,
					page:this.page,
				}
				this.$store.commit("yiliaoxin/set_zhuyuanParams",JSON.parse(JSON.stringify(this.zhuyuanParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'住院',data:JSON.parse(JSON.stringify(this.zhuyuanParams))})
			},
		},
		// beforeDestroy(){
		// 	this.zhuyuanParams.initialDataOflist = {
		// 		tabIndex:this.tabIndex,
		// 		search:this.search,
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_zhuyuanParams",JSON.parse(JSON.stringify(this.zhuyuanParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;height: 100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
